module.exports = __webpack_public_path__ + "static/media/hypertrons.80d455d1.jpg";